import { Box, Button, Grid } from "@mui/material";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import { useFormik } from "formik";
import CustomSelect from "../../../../components/CustomSelect";
import Flex from "../../../../components/Flex";
import Input from "../../../../components/Input";
import OutlineCard from "../../../../components/OutlineCard";
import Text from "../../../../components/Text";
import PasswordInput from "../../../../components/app/PasswordInput";
import { TIME_ZONE_LIST } from "../../../../constants";
import { useCreateTenantConfiguration } from "../../../../queries/admin/use-create-tenant-configurations";
import { useUpdateTenantConfiguration } from "../../../../queries/admin/use-update-tenant-configuration";
import { useTenantConfiguration } from "../../../../queries/use-get-tenant-configuration";
import { TenantConfiguration } from "../../../../services";

const INITIAL_VALUES: TenantConfiguration = {
  uuid: "",
  timeZone: "ADT",
  senderEmail: "",
  callerId: "",
  hostName: "",
  userName: "",
  email: "",
  verificationEmail: "",
  password: "",
  port: "",
  protocol: "",
  providerEmailCommunication: false,
  patientEmailCommunication: false,
  providerSmsCommunication: false,
  patientSmsCommunication: false,
  providerPushNotificationCommunication: false,
  patientPushNotificationCommunication: false,
  archive: false,
  active: false,
};

const TenantSettingsTenantConfiguration = () => {
  const {
    data: TenantConfigurationData,
    // isFetching,
    refetch,
    // isLoading: tableDataLoading,
  } = useTenantConfiguration({});

  const { mutateAsync: createTenantConfiguration } =
    useCreateTenantConfiguration();
  const { mutateAsync: updateTenantConfiguration } =
    useUpdateTenantConfiguration();
  const formik = useFormik({
    initialValues: TenantConfigurationData?.data ?? INITIAL_VALUES,
    onSubmit: () => {},
    enableReinitialize: true,
  });

  function TenantConfigurationHandler(payload: TenantConfiguration) {
    if (Object.keys(TenantConfigurationData?.data ?? {}).length > 0) {
      updateTenantConfiguration({ configuration: payload });
    } else {
      createTenantConfiguration({ configuration: payload }).then(() => {
        refetch();
      });
    }
  }

  return (
    <>
      <Text fontWeight={500} size={20} marginBottom={"20px"}>
        Tenant Configuration
      </Text>
      <Grid container spacing={2}>
        <Grid item xs={4} sm={4} md={4}>
          <Flex flexDirection={"column"} gap={"20px"}>
            <OutlineCard>
              <Text>
                Use below Buttons to Import Initial Data to your tenant
              </Text>
              <Divider sx={{ marginY: "10px" }} />
              <Button variant="outlined" sx={{ marginTop: "10px" }} fullWidth>
                Import Initial Data
              </Button>
            </OutlineCard>
            <OutlineCard>
              <Text fontWeight={500} size={18}>
                TIMEZONE
              </Text>
              <Divider sx={{ marginY: "10px" }} />

              <Flex gap={"10px"} alignItems={"center"}>
                <Box width={"70%"}>
                  <CustomSelect
                    value={formik.values.timeZone}
                    label="Current Timezone"
                    options={TIME_ZONE_LIST}
                    onChange={(value) => {
                      formik.setFieldValue("timeZone", value);
                    }}
                  />
                </Box>
                <Button
                  variant="outlined"
                  sx={{
                    width: "10rem",
                  }}
                  onClick={() => TenantConfigurationHandler(formik.values)}
                >
                  Change
                </Button>
              </Flex>
            </OutlineCard>
            <OutlineCard>
              <Text fontWeight={500} size={18}>
                Sender Email ID Verification
              </Text>
              <Divider sx={{ marginY: "10px" }} />
              <Text fontWeight={500} size={15}>
                Email ID
              </Text>
              <Text c="gray" variant="subtitle2">
                No Sender Email ID Set This Email will show when sending Emails
                From Platform
              </Text>
              <Flex gap={"10px"} alignContent={"center"}>
                <Box width={"70%"}>
                  <Input
                    label=""
                    textFieldProps={{
                      value: formik.values.senderEmail,
                      placeholder: "Enter Sender Email ID",
                      name: "senderEmail",
                      onChange: (e) => {
                        formik.setFieldValue(
                          "senderEmail",
                          e.currentTarget.value
                        );
                      },
                    }}
                  />
                </Box>
                <Button
                  variant="outlined"
                  sx={{
                    width: "10rem",
                  }}
                  onClick={() => {
                    TenantConfigurationHandler(formik.values);
                  }}
                >
                  Verify
                </Button>
              </Flex>
            </OutlineCard>
            <OutlineCard>
              <Text fontWeight={500} size={18}>
                Caller ID Verification
              </Text>
              <Divider sx={{ marginY: "10px" }} />
              <Text fontWeight={500} size={15}>
                Caller ID
              </Text>
              <Text c="gray" variant="subtitle2">
                This Phone Number will show when Calling From Platform
              </Text>
              <Flex gap={"10px"} alignContent={"center"}>
                <Box width={"70%"}>
                  <Input
                    label=""
                    textFieldProps={{
                      value: formik.values.callerId,
                      placeholder: "Enter Caller ID",
                      name: "callerId",
                      onChange: (e) => {
                        formik.setFieldValue("callerId", e.currentTarget.value);
                      },
                    }}
                  />
                </Box>
                <Button
                  variant="outlined"
                  sx={{
                    width: "10rem",
                  }}
                  onClick={() => {
                    TenantConfigurationHandler(formik.values);
                  }}
                >
                  Verify
                </Button>
              </Flex>
            </OutlineCard>
          </Flex>
        </Grid>
        <Grid item xs={4} sm={4} md={4}>
          <OutlineCard sx={{ height: "96.5%" }}>
            <Flex flexDirection={"column"} gap={"50px"}>
              <Box>
                <Text fontWeight={500} size={18}>
                  COMMUNICATIONS
                </Text>
                <Divider sx={{ marginY: "10px" }} />
                <Text fontWeight={500}>Block Provider Communication</Text>
                <Text c="gray">
                  This Will Block All Provider Communications
                </Text>
                <FormGroup
                  sx={{
                    marginLeft: "10px",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formik.values.providerEmailCommunication}
                        size="small"
                        onChange={(e) => {
                          TenantConfigurationHandler({
                            ...formik.values,
                            providerEmailCommunication: e.currentTarget.checked,
                          });
                          formik.setFieldValue(
                            "providerEmailCommunication",
                            e.currentTarget.checked
                          );
                        }}
                      />
                    }
                    label="Email"
                    sx={{
                      marginTop: "10px",
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        checked={formik.values.providerSmsCommunication}
                        onChange={(e) => {
                          TenantConfigurationHandler({
                            ...formik.values,
                            providerSmsCommunication: e.currentTarget.checked,
                          });
                          formik.setFieldValue(
                            "providerSmsCommunication",
                            e.currentTarget.checked
                          );
                        }}
                      />
                    }
                    label="SMS"
                    sx={{
                      marginTop: "10px",
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        checked={
                          formik.values.providerPushNotificationCommunication
                        }
                        onChange={(e) => {
                          TenantConfigurationHandler({
                            ...formik.values,
                            providerPushNotificationCommunication:
                              e.currentTarget.checked,
                          });
                          formik.setFieldValue(
                            "providerPushNotificationCommunication",
                            e.currentTarget.checked
                          );
                        }}
                      />
                    }
                    label="Push Notifications"
                    sx={{
                      marginTop: "10px",
                    }}
                  />
                </FormGroup>
              </Box>
              <Box>
                <Text fontWeight={500}>Block Patient Communication</Text>
                <Text c="gray">This Will Block All Patient Communications</Text>
                <FormGroup
                  sx={{
                    marginLeft: "10px",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        defaultChecked
                        size="small"
                        checked={formik.values.patientEmailCommunication}
                        onChange={(e) => {
                          TenantConfigurationHandler({
                            ...formik.values,
                            patientEmailCommunication: e.currentTarget.checked,
                          });
                          formik.setFieldValue(
                            "patientEmailCommunication",
                            e.currentTarget.checked
                          );
                        }}
                      />
                    }
                    label="Email"
                    sx={{
                      marginTop: "10px",
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        checked={formik.values.patientSmsCommunication}
                        onChange={(e) => {
                          TenantConfigurationHandler({
                            ...formik.values,
                            patientSmsCommunication: e.currentTarget.checked,
                          });
                          formik.setFieldValue(
                            "patientSmsCommunication",
                            e.currentTarget.checked
                          );
                        }}
                      />
                    }
                    label="SMS"
                    sx={{
                      marginTop: "10px",
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        checked={
                          formik.values.patientPushNotificationCommunication
                        }
                        onChange={(e) => {
                          TenantConfigurationHandler({
                            ...formik.values,
                            patientPushNotificationCommunication:
                              e.currentTarget.checked,
                          });
                          formik.setFieldValue(
                            "patientPushNotificationCommunication",
                            e.currentTarget.checked
                          );
                        }}
                      />
                    }
                    label="Push Notifications"
                    sx={{
                      marginTop: "10px",
                    }}
                  />
                </FormGroup>
              </Box>
            </Flex>
          </OutlineCard>
        </Grid>
        <Grid item xs={3} sm={3} md={3.7}>
          <OutlineCard sx={{ height: "96.5%" }}>
            <Flex
              justifyContent={"space-between"}
              flexDirection={"column"}
              height={"100%"}
            >
              <Box>
                <Flex justifyContent={"space-between"}>
                  <Text fontWeight={500} size={18}>
                    SMTP CONFIGURATIONS
                  </Text>
                  <FormControlLabel
                    control={
                      <Switch
                        defaultChecked
                        size="small"
                        checked={formik.values.active}
                        onChange={(e) => {
                          TenantConfigurationHandler({
                            ...formik.values,
                            active: e.currentTarget.checked,
                          });
                          formik.setFieldValue(
                            "active",
                            e.currentTarget.checked
                          );
                        }}
                      />
                    }
                    label="ON"
                  />
                </Flex>

                <Divider sx={{ marginY: "10px" }} />
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Input
                      label="Host Name"
                      textFieldProps={{
                        value: formik.values.hostName,
                        placeholder: "Enter Host Name",
                        name: "hostName",
                        onChange: (e) => {
                          formik.setFieldValue(
                            "hostName",
                            e.currentTarget.value
                          );
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Input
                      label="User Name"
                      textFieldProps={{
                        value: formik.values.userName,
                        placeholder: "Enter User Name",
                        name: "userName",
                        onChange: (e) => {
                          formik.setFieldValue(
                            "userName",
                            e.currentTarget.value
                          );
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Input
                      label="Email"
                      textFieldProps={{
                        value: formik.values.email,
                        placeholder: "Enter Email",
                        name: "email",
                        onChange: (e) => {
                          formik.setFieldValue("email", e.currentTarget.value);
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Input
                      label="Verification Email"
                      textFieldProps={{
                        value: formik.values.verificationEmail,
                        placeholder: "Enter Verification Email",
                        name: "verificationEmail",
                        onChange: (e) => {
                          formik.setFieldValue(
                            "verificationEmail",
                            e.currentTarget.value
                          );
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Grid container spacing={2}>
                      <Grid item md={5}>
                        <PasswordInput
                          label={"Password"}
                          size="small"
                          value={formik.values.password}
                          onChange={(value) => {
                            formik.setFieldValue("password", value);
                          }}
                        />
                      </Grid>
                      <Grid item md={3.5} marginTop={"32px"}>
                        <CustomSelect
                          value={formik.values.port}
                          label="Port"
                          options={[]}
                          placeholder="Select"
                          onChange={(value) => {
                            formik.setFieldValue("port", value);
                          }}
                        />
                      </Grid>
                      <Grid item md={3.5} marginTop={"32px"}>
                        <CustomSelect
                          value={formik.values.protocol}
                          label="Protocol"
                          options={[]}
                          placeholder="Select"
                          onChange={(value) => {
                            formik.setFieldValue("protocol", value);
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              <Button
                fullWidth
                variant="contained"
                sx={{
                  marginTop: "10px",
                }}
                onClick={() => TenantConfigurationHandler(formik.values)}
              >
                Save
              </Button>
            </Flex>
          </OutlineCard>
        </Grid>
      </Grid>
    </>
  );
};

export default TenantSettingsTenantConfiguration;
